import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-right"
      offset="80px"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:!bg-green-500/15 group-[.toaster]:!border-green-500/40 group-[.toaster]:!text-green-600 dark:group-[.toaster]:!text-green-400",
          error: "group-[.toaster]:!bg-red-500/15 group-[.toaster]:!border-red-500/40 group-[.toaster]:!text-red-600 dark:group-[.toaster]:!text-red-400",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
